import Game from '../../game';
import Element, { ElementParams } from '../element';
import Ship from '../ship/ship';

import { getAngleBy2XY } from '../../../utils/geometry';
import { Faction } from '../../../utils/faction';


export interface ResourceParams extends ElementParams {
  amount?: number;
}

export default class Resource extends Element implements ResourceParams {
  amount = 0;

  moveSpeedMax: number;
  tractedBy?: Ship;
  selectable = true;
  isInWarFog = false;
  faction = Faction.RESOURCE;
  moveSpeed = 500;

  constructor(params: ResourceParams) {
    super(params);
    this.applyParams(params);

    /* starts immobile */
    this.moveSpeedMax = this.moveSpeed;
    this.moveSpeed = 0;
  }

  update(modifier: number): Resource {
    this.moveByExternalVector(modifier);
    this.updateQuadtree();
    this.handleCollision();
    return this;
  }

  moveTowardsShip(modifier: number, ship?: Ship): void {
    if (!ship)
      return;

    if (!this.tractedBy)
      this.tractedBy = ship;

    if (this.tractedBy !== ship)
      return;

    const angleBetweenMeAndShip = getAngleBy2XY({
      x1: this.x,
      y1: this.y,
      x2: ship.x,
      y2: ship.y,
    });
    this.moveSpeed = this.moveSpeedMax; // the closer, the faster
    this.moveByDistanceAndAngle(this.moveSpeed * modifier, angleBetweenMeAndShip);
  }

  handleCollision(): void {
    const targetInCollision = this.getTargetsInCollision().map((e) => e instanceof Ship)[0];
    if (!targetInCollision)
      return;
    Game.instance.player.collectResources(this.amount);
    this.remove();
  }

  sortShipsByTractRange(elementsArray: Array<Ship>, order: 'asc' | 'desc' = 'asc'): Array<Ship> {
    if (elementsArray.length === 0)
      return [];
    return elementsArray
      .sort((a: Ship, b: Ship) => {
        if (order === 'desc')
          return b.tractorRange - a.tractorRange;
        else
          return a.tractorRange - b.tractorRange;

      })
      ;
  }
}
